import { TWebchatVisitorType } from 'modules/webchat/domain/entities';

/**
 * form → identifying → loginRequired (cliente) | creatingLead (novo) |
 * openingChat (cadastrado); creatingLead → openingChat. Em openingChat o
 * widget é montado com a identidade do visitante e aberto.
 */
export type TPreChatStep =
  | 'form'
  | 'identifying'
  | 'loginRequired'
  | 'creatingLead'
  | 'openingChat';

export interface IPreChatState {
  step: TPreChatStep;
  /** Tipo com que o widget será montado; null até a identificação. */
  visitorType: TWebchatVisitorType | null;
}

export type TPreChatEvent =
  | { type: 'SUBMITTED' }
  | { type: 'IDENTIFIED'; visitorType: TWebchatVisitorType }
  | { type: 'LEAD_CREATED' }
  | { type: 'LEAD_ALREADY_REGISTERED' }
  | { type: 'FAILED' }
  | { type: 'RESTARTED' };

export const PRE_CHAT_INITIAL_STATE: IPreChatState = {
  step: 'form',
  visitorType: null,
};

const STEP_AFTER_IDENTIFICATION: Record<TWebchatVisitorType, TPreChatStep> = {
  cliente: 'loginRequired',
  cadastrado: 'openingChat',
  novo: 'creatingLead',
};

export default function transitionPreChat(
  state: IPreChatState,
  event: TPreChatEvent,
): IPreChatState {
  if (event.type === 'RESTARTED') return PRE_CHAT_INITIAL_STATE;

  switch (state.step) {
    case 'form':
      return event.type === 'SUBMITTED'
        ? { step: 'identifying', visitorType: null }
        : state;

    case 'identifying':
      if (event.type === 'IDENTIFIED') {
        return {
          step: STEP_AFTER_IDENTIFICATION[event.visitorType],
          visitorType: event.visitorType,
        };
      }

      return event.type === 'FAILED' ? PRE_CHAT_INITIAL_STATE : state;

    case 'creatingLead':
      if (event.type === 'LEAD_CREATED') {
        return { step: 'openingChat', visitorType: 'novo' };
      }

      if (event.type === 'LEAD_ALREADY_REGISTERED') {
        return { step: 'openingChat', visitorType: 'cadastrado' };
      }

      return event.type === 'FAILED' ? PRE_CHAT_INITIAL_STATE : state;

    default:
      return state;
  }
}
